/*
 * @Author: Josselin Hubert
 * @Date: 2020-09-01 22:38:54
 * @Last Modified by:   Josselin Hubert
 * @Last Modified time: 2020-09-01 22:38:54
 */


<template>
  <section id="home">
    <hero />

    <contents />
  </section>
</template>

<script>
  export default {
    name: "HomeIndex",

    metaInfo: {
      title: "Premium Development",
    },

    components: {
      Hero: () => import("./Hero"),
      Contents: () => import("./Contents"),
    },
  };
</script>
